import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host([theme]) {
    border-radius: 3px;
    box-sizing: border-box;
    border: none;
    padding: 0 15px;
    white-space: nowrap;
    height: 44px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @apply --type-base;
    @apply --type16;
    @apply --heavy;
    min-width: var(--com-button-min-width, 130px);
    max-width: var(--com-button-max-width, 250px);
    width: 100%;
  }
  :host(:hover) {
    text-decoration: none;
  }
  :host([disabled]) {
    cursor: default;
    pointer-events: none;
  }
  :host([theme="primary"]) {
    background-color: var(--primary-action);
    border: 2px solid var(--primary-action);
    color: white;
  }
  :host([theme="primary"]:not([disabled]):focus),
  :host([theme="primary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
  }
  :host([theme="primary"]:not([disabled]):hover),
  :host([theme="primary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
  }
  :host([theme="primary"][active]:not([disabled])),
  :host([theme="primary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="primary"]:not([disabled]):active),
  :host([theme="primary"]:not([disabled]).active),
  :host([theme="primary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="primary"][disabled]) {
    background-color: var(--primary-disabled);
    border: 2px solid var(--primary-disabled);
  }
  :host([theme="primary-full-width"]) {
    background-color: var(--primary-action);
    border: 2px solid var(--primary-action);
    color: white;
    max-width: 100%;
  }
  :host([theme="primary-full-width"]:not([disabled]):focus),
  :host([theme="primary-full-width"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
  }
  :host([theme="primary-full-width"]:not([disabled]):hover),
  :host([theme="primary-full-width"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
  }
  :host([theme="primary-full-width"][active]:not([disabled])),
  :host([theme="primary-full-width"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="primary-full-width"]:not([disabled]):active),
  :host([theme="primary-full-width"]:not([disabled]).active),
  :host([theme="primary-full-width"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="primary-full-width"][disabled]) {
    background-color: var(--primary-disabled);
    border: 2px solid var(--primary-disabled);
  }
  :host([theme="secondary"]) {
    background-color: white;
    border: 2px solid var(--primary-action);
    color: var(--primary-action);
  }
  :host([theme="secondary"]:not([disabled]):focus),
  :host([theme="secondary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
    color: white;
  }
  :host([theme="secondary"]:not([disabled]):hover),
  :host([theme="secondary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
    color: white;
  }
  :host([theme="secondary"][active]:not([disabled])),
  :host([theme="secondary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="secondary"]:not([disabled]):active),
  :host([theme="secondary"]:not([disabled]).active),
  :host([theme="secondary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="secondary"][disabled]) {
    border: 2px solid var(--primary-disabled);
    color: var(--primary-disabled);
  }
  :host([theme="tertiary"]) {
    background-color: var(--background-component);
    border: 2px solid var(--background-component);
    color: var(--primary-action);
  }
  :host([theme="tertiary"]:not([disabled]):focus),
  :host([theme="tertiary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
    color: white;
  }
  :host([theme="tertiary"]:not([disabled]):hover),
  :host([theme="tertiary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
    color: white;
  }
  :host([theme="tertiary"][active]:not([disabled])),
  :host([theme="tertiary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="tertiary"]:not([disabled]):active),
  :host([theme="tertiary"]:not([disabled]).active),
  :host([theme="tertiary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="tertiary"][disabled]) {
    background-color: var(--background-component);
    border: 2px solid var(--background-component);
    color: var(--primary-disabled);
  }
  :host([theme="pill-primary"]) {
    background-color: white;
    border: 1px solid var(--primary-action);
    color: var(--primary-action);
    border-radius: 18px;
    width: auto;
    min-width: auto;
    padding: 0 var(--com-button-padding, 30px);
    margin-right: 1px;
    height: 36px;
    margin-right: 8px;
    @apply --type12;
  }
  :host([theme="pill-primary"]:not([disabled]):hover),
  :host([theme="pill-primary"]:not([disabled]).hover) {
    background-color: white;
    border-color: var(--primary-hover);
    color:var(--primary-hover);
    border: 1px solid var(--primary-hover);
    outline: none;
    text-decoration: none;
  }
  :host([theme="pill-primary"]:not([disabled]):focus),
  :host([theme="pill-primary"]:not([disabled]).focus) {
    outline: 2px solid var(--focus-blue);
  }
  :host([theme="pill-primary-no-border"]) {
    color: var(--primary-action);
    width: auto;
    min-width: auto;
    padding: 0 var(--com-button-padding, 30px);
    margin-right: 1px;
    height: 36px;
    margin-right: 8px;
    @apply --type12;
  }
  :host([theme="pill-primary-no-border"]:not([disabled]):hover),
  :host([theme="pill-primary-no-border"]:not([disabled]).hover) {
    color:var(--primary-hover);
    outline: none;
    text-decoration: none;
  }
  :host([theme="pill-primary-no-border"]:not([disabled]):focus),
  :host([theme="pill-primary-no-border"]:not([disabled]).focus) {
    outline: 2px solid var(--focus-blue);
  }
  :host([theme="transactional"]) {
    background-color: var(--transactional-action);
    border: 2px solid var(--transactional-action);
    color: white;
  }
  :host([theme="transactional"]:not([disabled]):focus),
  :host([theme="transactional"]:not([disabled]).focus) {
    background-color: var(--transactional-hover);
    border: 2px solid black;
  }
  :host([theme="transactional"]:not([disabled]):hover),
  :host([theme="transactional"]:not([disabled]).hover) {
    background-color: var(--transactional-hover);
    border: 2px solid var(--transactional-hover);
  }
  :host([theme="transactional"][active]:not([disabled])),
  :host([theme="transactional"][active]:not([disabled])) {
    background-color: var(--transactional-active);
    border: 2px solid var(--transactional-active);
  }
  :host([theme="transactional"]:not([disabled]):active),
  :host([theme="transactional"]:not([disabled]).active),
  :host([theme="transactional"][pressed]:not([disabled])) {
    background-color: var(--transactional-active);
    border: 2px solid var(--transactional-active);
  }
  :host([theme="transactional"][disabled]) {
    background-color: var(--transactional-disabled);
    border: 2px solid var(--transactional-disabled);
  }
  :host([theme="action"]) {
    background: transparent;
    border: 2px solid white;
    color: white;
  }
  :host([theme="action"]:not([disabled]):focus),
  :host([theme="action"]:not([disabled]).focus) {
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid black;
  }
  :host([theme="action"]:not([disabled]):hover),
  :host([theme="action"]:not([disabled]).hover) {
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid white;
  }
  :host([theme="action"]:not([disabled]):active),
  :host([theme="action"]:not([disabled]).active),
  :host([theme="action"][pressed]:not([disabled])) {
    background: rgba(0, 0, 0, 0.6);
    border: 2px solid white;
  }
  :host([theme="action"][disabled]) {
    border: 2px solid rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.5);
  }
  :host([theme="apple-pay"]) {
    background-color: black;
    border-radius: 30px;
    color: white;
    font-size: 19px;
    font-weight: 600;
  }
  :host([theme="hyperion-primary"]) {
    background-color: var(--primary-action);
    border: 2px solid var(--primary-action);
    border-radius: 30px;
    color: white;
  }
  :host([theme="hyperion-primary"]:not([disabled]):focus),
  :host([theme="hyperion-primary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
  }
  :host([theme="hyperion-primary"]:not([disabled]):hover),
  :host([theme="hyperion-primary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
  }
  :host([theme="hyperion-primary"][active]:not([disabled])),
  :host([theme="hyperion-primary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="hyperion-primary"]:not([disabled]):active),
  :host([theme="hyperion-primary"]:not([disabled]).active),
  :host([theme="hyperion-primary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
  }
  :host([theme="hyperion-primary"][disabled]) {
    background-color: var(--primary-disabled);
    border: 2px solid var(--primary-disabled);
  }
  :host([theme="hyperion-secondary"]) {
    background-color: white;
    border: 2px solid var(--primary-action);
    border-radius: 30px;
    color: var(--primary-action);
  }
  :host([theme="hyperion-secondary"]:not([disabled]):focus),
  :host([theme="hyperion-secondary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
    color: white;
  }
  :host([theme="hyperion-secondary"]:not([disabled]):hover),
  :host([theme="hyperion-secondary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
    color: white;
  }
  :host([theme="hyperion-secondary"][active]:not([disabled])),
  :host([theme="hyperion-secondary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="hyperion-secondary"]:not([disabled]):active),
  :host([theme="hyperion-secondary"]:not([disabled]).active),
  :host([theme="hyperion-secondary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="hyperion-secondary"][disabled]) {
    border: 2px solid var(--primary-disabled);
    color: var(--primary-disabled);
  }
  :host([theme="hyperion-tertiary"]) {
    background-color: var(--background-component);
    border: 2px solid var(--message-grey);
    border-radius: 30px;
    color: var(--message-grey);
  }
  :host([theme="hyperion-tertiary"]:not([disabled]):focus),
  :host([theme="hyperion-tertiary"]:not([disabled]).focus) {
    background-color: var(--primary-hover);
    border: 2px solid black;
    color: white;
  }
  :host([theme="hyperion-tertiary"]:not([disabled]):hover),
  :host([theme="hyperion-tertiary"]:not([disabled]).hover) {
    background-color: var(--primary-hover);
    border: 2px solid var(--primary-hover);
    color: white;
  }
  :host([theme="hyperion-tertiary"][active]:not([disabled])),
  :host([theme="hyperion-tertiary"][active]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="hyperion-tertiary"]:not([disabled]):active),
  :host([theme="hyperion-tertiary"]:not([disabled]).active),
  :host([theme="hyperion-tertiary"][pressed]:not([disabled])) {
    background-color: var(--primary-active);
    border: 2px solid var(--primary-active);
    color: white;
  }
  :host([theme="hyperion-tertiary"][disabled]) {
    background-color: var(--primary-disabled);
    border: 2px solid var(--primary-disabled);
  }
  :host([theme="hyperion-transactional"]) {
    background-color: var(--transactional-action);
    border: 2px solid var(--transactional-action);
    border-radius: 30px;
    color: white;
  }
  :host([theme="hyperion-transactional"]:not([disabled]):focus),
  :host([theme="hyperion-transactional"]:not([disabled]).focus) {
    background-color: var(--transactional-hover);
    border: 2px solid black;
  }
  :host([theme="hyperion-transactional"]:not([disabled]):hover),
  :host([theme="hyperion-transactional"]:not([disabled]).hover) {
    background-color: var(--transactional-hover);
    border: 2px solid var(--transactional-hover);
  }
  :host([theme="hyperion-transactional"][active]:not([disabled])),
  :host([theme="hyperion-transactional"][active]:not([disabled])) {
    background-color: var(--transactional-active);
    border: 2px solid var(--transactional-active);
  }
  :host([theme="hyperion-transactional"]:not([disabled]):active),
  :host([theme="hyperion-transactional"]:not([disabled]).active),
  :host([theme="hyperion-transactional"][pressed]:not([disabled])) {
    background-color: var(--transactional-active);
    border: 2px solid var(--transactional-active);
  }
  :host([theme="hyperion-transactional"][disabled]) {
    background-color: var(--transactional-disabled);
    border: 2px solid var(--transactional-disabled);
  }
  :host([theme="dlp-primary"]) {
    background-image: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    border-radius: 30px;
    color: #fff;
  }
  :host([theme="dlp-primary"]:not([disabled]):hover),
  :host([theme="dlp-primary"]:not([disabled]).hover) {
    background-image: linear-gradient(to right, #022CA5, #0146C6);
  }
  :host([theme="dlp-primary"][disabled]) {
    background-image: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    opacity: 0.3;
  }
  :host([theme="dlp-primary"]:not([disabled]):focus),
  :host([theme="dlp-primary"]:not([disabled]).focus) {
    position: relative;
    box-sizing: border-box;
    background: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    background-clip: padding-box;
    border: solid 2px transparent;
  }
  :host([theme="dlp-primary"]:not([disabled]):focus)::before,
  :host([theme="dlp-primary"]:not([disabled]).focus)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: -2px;
    border-radius: inherit;
    background: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    z-index: -1;
  }
  :host([theme="dlp-secondary"]) {
    position: relative;
    box-sizing: border-box;
    color: var(--dlp-primary-hover);
    background: #fff;
    background-clip: padding-box;
    border: solid 2px transparent;
    border-radius: 30px;
  }
  :host([theme="dlp-secondary"])::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: -2px;
    border-radius: inherit;
    background: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    z-index: -1;
  }
  :host([theme="dlp-secondary"]:not([disabled]):hover),
  :host([theme="dlp-secondary"]:not([disabled]).hover) {
    background-color: #f2f3f4;
  }
  :host([theme="dlp-secondary"][disabled]) {
    background: #fff;
    opacity: 0.3;
  }
  :host([theme="dlp-secondary"]:not([disabled]):focus),
  :host([theme="dlp-secondary"]:not([disabled]).focus) {
    position: relative;
    box-sizing: border-box;
    background: white;
    background-clip: padding-box;
    border: solid 2px transparent;
  }
  :host([theme="dlp-secondary"]:not([disabled]):focus)::before,
  :host([theme="dlp-secondary"]:not([disabled]).focus)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: -2px;
    border-radius: inherit;
    background: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    z-index: -1;
  }
  :host([theme="dlp-secondary"][active]:not([disabled])),
  :host([theme="dlp-secondary"][active]:not([disabled])) {
    background: linear-gradient(to right, var(--dlp-primary-hover), #005bff);
    color: white;
  }

  :host([theme="outer-shadow-box"]) {
    height: 158px;
    min-width: var(--com-button-min-width, 160px);
    max-width: var(--com-button-min-width, 160px);
    background-color: white;
    border: 1px solid #e6edef;
    border-radius: 0px;
    color: var(--foreground-header);
    box-shadow: 0 4px 10px 0 rgba(192, 193, 252, 0.33);
    text-wrap: wrap;
  }

  :host([theme="outer-shadow-box"]:not([disabled]):hover),
  :host([theme="outer-shadow-box"]:not([disabled]).hover),
  :host([theme="outer-shadow-box"]:not([disabled]):focus),
  :host([theme="outer-shadow-box"]:not([disabled]).focus),
  :host([theme="outer-shadow-box"][pressed]:not([disabled])) {
    color: #1994d7;
  }
</style>
</template>`;

styleElement.register('com-button-style');